// :cow: Cosmose CONFIDENTIAL :iso:
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, STATE_NAME } from './select-category.reducer';

export const featureState = createFeatureSelector<State>(STATE_NAME);

export const selectIsLoading = createSelector(
  featureState,
  (state: State) => state.isLoading,
);

export const selectCategories = createSelector(
  featureState,
  (state: State) => state.categoriesResponse ? state.categoriesResponse : [],
);
